import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';
import { parseTonightSearch, searchParams } from '../../sessions/core/tonight-model.js';
import { TonightPage } from '../../sessions/tonight/tonight-page.js';

/**
 * `/tonight` (2.D deliverable 1): guarded like every other authenticated route; `?session=<id>`
 * and `?closed=<sections>`. With the `sessions` flag off the page is the not-found page. The
 * validated search keeps the address's form (`closed` a comma list), which the page parses; an
 * array here would be written back to the address as JSON and missed by the page's parse.
 */
export const Route = createFileRoute('/tonight/')({
  staticData: { crumb: 'Tonight' },
  validateSearch: (raw: Record<string, unknown>) => searchParams(parseTonightSearch(raw)),
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  component: TonightPage,
});
